import React, { Component } from 'react';
import {
    EXTRACT_TEMPLATE_MODULES,
    FILE_NAME_TEMPLATE,
    UPLOAD_TYPES,
    MODAL_CUSTOM_MESSAGE,
    DEBITOR_UPLOAD_TYPES_MESSAGE,
    DEBITOR_UPLOAD_TYPES_ID,
    DEBITOR_UPLOAD_FILE_LIMITATION,
    DOWNLOAD_TEMPLATE_lABEL
} from '../../../../../constants/external-constants';

import { Button } from 'react-bootstrap';
import Translation from '../../../../common/translation/translation.component';
import DragDropUpload from '../../../../common/upload/drag-drop-upload/drag-drop-upload.component';
import { SelectFieldFloatingLabel as Select } from '../../../../common/custom-form/select-filter.component';
import { Loading } from '../../../../common/loading/index';
import { connect } from 'react-redux';
import { validateAccessModule } from "../../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../../utils/rbac-constants.utils";
import { DebitorCatalogueUploadAction } from '../../../../../store/external/recharge-reducer/debitor-catalogue-upload-reducer/debitor-catalogue-upload-reducer';
import { bindActionCreators } from 'redux';
import { TRANSLATIONS } from '../../../../../utils/constant.utils';

class DebitorUpload extends Component{

    constructor(props) {
        super(props);

        this.childRef = React.createRef();

        this.state = {
            vendor: null,
            extractAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            uploadInProgress: false,
            uploadInProgress: false,
            isLoading: true,
            filterLoading: false,
            loadingLabel: "",
            errorModal: {
                show: false,
                title: "",
                message: ""
            },
        };
    }

    async componentDidMount() {
        const { getDebitorCatalogueUploadTypes, resetDebitorUploadForm } = this.props;
        await resetDebitorUploadForm();
        await getDebitorCatalogueUploadTypes().then(() => {this.setState({ isLoading: false })});
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];

        return TRANSLATIONS[locale][key];
    }

    handleChangeVendor = (Id) => {
        this.setState({
            vendor: Id
        });
    }
    onClickDownload = () => {
        if (window.confirm(this.state.extractAlertMsg)) {
           
        }
    }
    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    dropDragDisable = () => {
        const { debitorUploadForm } = this.props;
        const requiredField = !(debitorUploadForm.debitorCatalogueUploadTypeId);

        return requiredField;
    }

    handleDownloadTemplate = () => {
        const { downloadDebitorCatalogueUploadTemplate } = this.props;
        this.setState({
            filterLoading: true,
            loadingLabel: "Downloading"
        })
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            downloadDebitorCatalogueUploadTemplate(EXTRACT_TEMPLATE_MODULES.debitorCatalogueTemplate, FILE_NAME_TEMPLATE.debitorUploadTemplate).then(() => {
                this.setState({
                    filterLoading: false,
                    loadingLabel: ""
                })
            });;
        } else {
            this.setState({
                filterLoading: false,
                loadingLabel: ""
            })
        } 
    }

    handleSuccessProcess = (data) => {
        const { postExecuteProcess } = this.props;
        postExecuteProcess(data.UploadId);
        this.setState({
            uploadInProgress: false
        });
    }

    handleAddFiles = () => {
        this.forceUpdate();
    }

    handleRemoveFiles = () => {
        this.forceUpdate();
    }

    djsConfigParams = () => {

        const { debitorUploadForm } = this.props;
    
        var baseParams = {
            DebitorUploadTypeId: debitorUploadForm.debitorCatalogueUploadTypeId
        };

        var djsConfig = {
            params: {
                CreatedBy: sessionStorage.getItem('EID').toString(),
                UserId: sessionStorage.getItem('UserID').toString(),
                UploadTypeId: UPLOAD_TYPES.DebitorUpload,
                ChargeTypeDetails: JSON.stringify({
                    ...baseParams,
                }), 
            },
            maxFiles: DEBITOR_UPLOAD_FILE_LIMITATION.maxFiles,
            minFiles: DEBITOR_UPLOAD_FILE_LIMITATION.minFiles,
            acceptedFiles: DEBITOR_UPLOAD_FILE_LIMITATION.acceptedFiles,
            dictInvalidFileType: this.toLocaleLanguage('error_invalid_file_type'),
            dictMaxFilesExceeded: this.toLocaleLanguage('error_exceeded_maximum_file'),
            dictErrorOccured: this.toLocaleLanguage('error_occured_reupload_file')
        };

        return djsConfig;
    }

    disabledUpload = () => {
        const { debitorUploadForm } = this.props;
        const intialField = !(!debitorUploadForm.debitorCatalogueUploadTypeId);

        let validFiles = false;
        if (this.childRef.current) {
            validFiles = this.childRef.current.checkValidFileForm();
        }

        return !(intialField && validFiles);
    }

    handleUpload = () => {
        if (this.childRef.current) {
            this.childRef.current.processQueue();
        }
        this.setState({
            uploadInProgress: true
        });
    }

    onErrorUpload = () => {
        this.setState({
            uploadInProgress: false
        })
    }

    render() {
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingDebitorCatalogueDashboardRW])

        const { debitorUploadForm, onDebitorCatalogueUploadTypeSelect } = this.props;
        const { debitorCatalogueUploadTypeOptions } = this.props.debitorUpload

        return (
            <div className="rate-card-upload upload__container ">
                {
                    this.state.filterLoading &&
                    <Loading customClass="filter-loading" label={this.state.loadingLabel} />
                }
                <div className="invoice-mapping-container">
                    <div className="field-section">
                        <div className="field-content">

                            <Translation
                                getOnlyText={true}
                                onChangeTranslation={this.onChangeExtractAlertMsg}
                                translationKey={"export_alert_message"} />
                            
                            <div className="spacer" />
                            <Select
                                className="form-select required"
                                label={`${this.toLocaleLanguage('upload_type')}`}
                                options={debitorCatalogueUploadTypeOptions}
                                value={debitorUploadForm.debitorCatalogueUploadTypeId ?? ""}
                                placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                isError={false}
                                fieldProp='debitorUploadForm.debitorCatalogueUploadTypeId'
                                disabled={!isReadAndWrite}
                                onChangeAction={onDebitorCatalogueUploadTypeSelect}
                                optionLabelKey={{
                                    Key: "Key",
                                    Value: "Value"
                                }}
                            />

                           {debitorUploadForm.debitorCatalogueUploadTypeId === DEBITOR_UPLOAD_TYPES_ID.New ?
                                <span className="pending-upload-message">{DEBITOR_UPLOAD_TYPES_MESSAGE.New}</span> : null
                            }

                            {debitorUploadForm.debitorCatalogueUploadTypeId === DEBITOR_UPLOAD_TYPES_ID.AddUpdate ?
                                <span className="pending-upload-message">{DEBITOR_UPLOAD_TYPES_MESSAGE.AddUpdate}</span> : null
                            }

                          
                            <div className="spacer" />

                        </div>
                    </div>

                    <div className="upload-section">
                        <div className="upload-content">
                            <DragDropUpload
                                ref={this.childRef}
                                buttonLabel={DOWNLOAD_TEMPLATE_lABEL.debitor_catalogue}
                                disabled={this.dropDragDisable() || !isReadAndWrite }
                                downloadButton={this.handleDownloadTemplate}
                                djsConfigParams={this.djsConfigParams()}
                                onSuccessProcess={this.handleSuccessProcess}
                                onAddFiles={this.handleAddFiles}
                                onRemoveFiles={this.handleRemoveFiles}
                                uploadTypeId={UPLOAD_TYPES.DebitorUpload}
                                onErrorUpload={this.onErrorUpload}
                            />
                        </div>
                    </div>

                    <div className="upload-btn-section">
                        <div className="save-btn-container">
                            <Button disabled={this.disabledUpload() || this.state.uploadInProgress || !isReadAndWrite } onClick={this.handleUpload} className="save-details-btn">Upload</Button>
                        </div>
                    </div>

                </div>
            </div>

        );
    }

}
   

export default connect(
    state => {
        const { translation, debitorUpload } = state;

        const { debitorUploadForm } = state.form;
       
        return {
            translation
            , debitorUpload
            , debitorUploadForm
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, DebitorCatalogueUploadAction),
        dispatch
    )
)(DebitorUpload);